import { Layout } from 'antd'
import { NavLink } from 'react-router-dom'
import DiwaIcon from '../Svg/DiwaIcon'
import OmnichannelIcon from '../Svg/OmnichannelIcon'
import SettingsIcon from '../Svg/SettingsIcon'
import {
  ConfigurationForm,
  Env,
  UiCodePricesOmnichannel,
  UiCodeSettings,
  UiCodeUtility,
} from '../../Constants/Configuration'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { CLIENT_PAGES_PATH } from '../../Constants/ClientRoutes'
import { useAppSelector } from '../../hooks'
import RenderByProfileOptionWrapper from './RenderByProfileOptionWrapper'
import UtilityIcon from 'Components/Svg/Utility'

const { Sider } = Layout

function SideNavigation() {
  const language = useAppSelector(state => state.present.language.value)
  const formConfigurationValue = useAppSelector(state => state.present.configuration.formConfigurationValue)
  const isOmnichannelAndPricesVisibile = useAppSelector(
    state => state.present.configuration.isOmnichannelAndPricesVisibile,
  )
  const isSettingsVisible = useAppSelector(state => state.present.configuration.settingsVisibility)
  const isFromMV = useAppSelector(state => state.present.configuration.isFromMV)
  const isOmnichannelVisible = useAppSelector(state => state.present.configuration.isOmnichannelVisible)
  const isConfigurationFormGruccia = formConfigurationValue === ConfigurationForm.GRUCCIA
  const enableSider = (isOmnichannelAndPricesVisibile || isSettingsVisible) && !isFromMV && isOmnichannelVisible

  return enableSider ? (
    <Sider width={74} className='layout-sider' collapsed={isConfigurationFormGruccia} collapsedWidth={0}>
      <NavLink
        className={({ isActive }) => (isActive ? 'sider-nav active' : 'sider-nav')}
        to={CLIENT_PAGES_PATH.Homepage}
      >
        <div>
          <DiwaIcon className='generic-icon sider-icon' />
        </div>
        <div className='sider-text'>{renderTranslation(language, TranslationKeys.diwa)}</div>
      </NavLink>
      <RenderByProfileOptionWrapper sectionName={UiCodePricesOmnichannel}>
        <NavLink
          className={({ isActive }) => (isActive ? 'sider-nav active' : 'sider-nav')}
          to={CLIENT_PAGES_PATH.Omnichannel}
        >
          <div>
            <OmnichannelIcon className='generic-icon sider-icon' />
          </div>
          <div className='sider-text'>{renderTranslation(language, TranslationKeys.omnichannel)}</div>
        </NavLink>
      </RenderByProfileOptionWrapper>
      <RenderByProfileOptionWrapper sectionName={UiCodeUtility}>
        <NavLink
          className={({ isActive }) => (isActive ? 'sider-nav active' : 'sider-nav')}
          to={CLIENT_PAGES_PATH.Utility}
        >
          <div>
            <UtilityIcon className='generic-icon sider-icon' />
          </div>
          <div className='sider-text'>{renderTranslation(language, TranslationKeys.utility)}</div>
        </NavLink>
      </RenderByProfileOptionWrapper>
      {isSettingsVisible ? (
        <RenderByProfileOptionWrapper sectionName={UiCodeSettings}>
          <NavLink
            className={({ isActive }) => (isActive ? 'sider-nav active' : 'sider-nav')}
            to={CLIENT_PAGES_PATH.Settings}
          >
            <div>
              <SettingsIcon className='generic-icon sider-icon' />
            </div>
            <div className='sider-text'>{renderTranslation(language, TranslationKeys.settings)}</div>
          </NavLink>
        </RenderByProfileOptionWrapper>
      ) : null}
    </Sider>
  ) : (
    //Empty sider element is set to prevent page flex propety unproperly collapse on open and render page inappropriately
    <Sider collapsed={true} collapsedWidth={0} />
  )
}

export default SideNavigation
